const processType = {
  dangXuLy: 'DANG_XU_LY',
  daXuLy: 'DA_XU_LY',
  xuLyDon: {
    name: 'XU_LY_DON',
    processing: {
      lanhDaoThuHoi: 'LANH_DAO_THU_HOI',
      truongPhongThuHoi: 'TRUONG_PHONG_THU_HOI',
      yeuCauGapLanhDao: 'YEU_CAU_GAP_LANH_DAO',
      trinhLanhDao: 'TRINH_LANH_DAO',
      trinhTruongPhong: 'TRINH_TRUONG_PHONG',
      lanhDaoGiaoViecTruongPhong: 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG',
      lanhDaoGiaoViecChuyenVien: 'LANH_DAO_GIAO_VIEC_CAN_BO',
      truongPhongGiaoViecChuyenVien: 'TRUONG_PHONG_GIAO_VIEC_CAN_BO',
      truongPhongGiaoViecPhoPhong: 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG',
      deXuatGiaoViecLai: 'DE_XUAT_GIAO_VIEC_LAI',
      ketThuc: 'KET_THUC',
      dinhChi: 'DINH_CHI',
    },
    huongXuLy: {
      traDonChuyenKhongDungThamQuyen: 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN',
      yeuCauGapLanhDao: 'YEU_CAU_GAP_LANH_DAO',
      traDonVaHuongDan: 'TRA_DON_VA_HUONG_DAN',
      khongDuDieuKienThuLy: 'KHONG_DU_DIEU_KIEN_THU_LY',
      luuDonVaTheoDoi: 'LUU_DON_VA_THEO_DOI',
      khongXuLyNeuLyDo:'KHONG_XU_LY_NEU_LY_DO',
      huongDanVietLaiDon: 'HUONG_DAN_VIET_LAI_DON',
      chuyenDon: 'CHUYEN_DON',
      deXuatThuLy: 'DE_XUAT_THU_LY'
    }
  } ,
  giaiQuyetDon: {
    name: 'GIAI_QUYET_DON'
  }

}

export { processType };



// WEBPACK FOOTER //
// ./src/constants/process-type.js